import { ModifyContextState } from 'context/toastContext';

const actionTypeBlacklist = ['leadModalPatchComposerEmail', 'leadModalPatchComposerPhone', 'uiSetFormInvalidField'];

export const toastsMiddleware = () => (next) => (action) => {
  if (ModifyContextState) {
    if (action.payload && action.payload.message && !action.payload.type && !actionTypeBlacklist.includes(action.type)) {
      ModifyContextState.setToastMessage(action.payload.message);
    }
  }
  return next(action);
};
